import React, { Component } from 'react';
import Metrics from '@spotahome/soyuz-metrics';

const withModalHandle = trackProps => WrappedComponent => {
  class ComponentWithModal extends Component {
    state = {
      isModalOpen: false
    };

    sendGaEvent = ({ eventCategory, eventAction, eventLabel }) => {
      Metrics.ga.sendEvent(eventCategory, eventAction, eventLabel);
    };

    onHandleOpen = e => {
      e && e.preventDefault();
      if (trackProps && trackProps.open) {
        this.sendGaEvent(trackProps.open);
      }
      this.setState({
        isModalOpen: true
      });
    };

    onHandleClose = e => {
      e && e.preventDefault();
      if (trackProps && trackProps.close) {
        this.sendGaEvent(trackProps.close);
      }
      this.setState({
        isModalOpen: false
      });
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          handleModalOpen={this.onHandleOpen}
          handleModalClose={this.onHandleClose}
          isModalOpen={this.state.isModalOpen}
        />
      );
    }
  }
  return ComponentWithModal;
};

export default withModalHandle;
